/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START _action_dialog.component.scss.shim.ngstyle,_angular_core,_action_dialog.component PURE_IMPORTS_END */
/** PURE_IMPORTS_START _action_dialog.component.scss.shim.ngstyle,_angular_core,_action_dialog.component PURE_IMPORTS_END */
import * as i0 from "./action-dialog.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./action-dialog.component";
var styles_ActionDialogComponent = [i0.styles];
var RenderType_ActionDialogComponent = /*@__PURE__*/ i1.ɵcrt({ encapsulation: 0, styles: styles_ActionDialogComponent, data: {} });
export { RenderType_ActionDialogComponent as RenderType_ActionDialogComponent };
export function View_ActionDialogComponent_0(_l) {
    return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 19, "div", [["class", "nsf-action-dialog"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n    "])), (_l()(), i1.ɵeld(2, 0, null, null, 16, "div", [["class", "nsf-action-dialog__inner"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n        "])), (_l()(), i1.ɵeld(4, 0, null, null, 4, "div", [["class", "nsf-action-dialog__box"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n            "])), (_l()(), i1.ɵeld(6, 0, null, null, 1, "div", [["class", "nsf-action-dialog__text"]], null, null, null, null, null)), i1.ɵncd(null, 0), (_l()(), i1.ɵted(-1, null, ["\n        "])), (_l()(), i1.ɵted(-1, null, ["\n        "])), (_l()(), i1.ɵeld(10, 0, null, null, 7, "div", [["class", "nsf-action-dialog__actions"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n            "])), (_l()(), i1.ɵeld(12, 0, null, null, 1, "a", [["class", "no"], ["href", "#"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                $event.preventDefault();
                var pd_0 = (_co.handleNo() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i1.ɵted(-1, null, ["Nein"])), (_l()(), i1.ɵted(-1, null, ["\n            "])), (_l()(), i1.ɵeld(15, 0, null, null, 1, "a", [["class", "yes"], ["href", "#"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                $event.preventDefault();
                var pd_0 = (_co.handleYes() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i1.ɵted(-1, null, ["Ja"])), (_l()(), i1.ɵted(-1, null, ["\n        "])), (_l()(), i1.ɵted(-1, null, ["\n    "])), (_l()(), i1.ɵted(-1, null, ["\n"])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, null);
}
export function View_ActionDialogComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "action-dialog", [], null, null, null, View_ActionDialogComponent_0, RenderType_ActionDialogComponent)), i1.ɵdid(1, 1097728, null, 0, i2.ActionDialogComponent, [i1.ElementRef], null, null)], null, null); }
var ActionDialogComponentNgFactory = /*@__PURE__*/ i1.ɵccf("action-dialog", i2.ActionDialogComponent, View_ActionDialogComponent_Host_0, { onYes: "onYes", onNo: "onNo", opened: "opened" }, {}, ["*"]);
export { ActionDialogComponentNgFactory as ActionDialogComponentNgFactory };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/action-dialog/action-dialog.component.ngfactory.js
// module id = null
// module chunks = 